import { makeStyles } from '@material-ui/core/styles';
export const useFormFileUploadStyles = makeStyles(theme => ({
  form: {
    flexGrow: 1
  },
  container: {
    width: '35rem'
  }
}));
